module.exports = __webpack_public_path__ + "static/media/excavation-6.d7153820.jpg";